<div class="iptv-dialog">
  <div class="iptv-dialog__header align-items-center">
    <h1 class="channel-dialog-title" mat-dialog-title data-testId="channel-dialog-title">
      {{ getTitle() }}
    </h1>
    <div>
      <button *ngIf="data.code === 'edit-channel'" mat-button mat-stroked-button class="schedule-button"
        data-testId="edit-program-guide-button" (click)="openEditProgramGuideDialog(data.channel)">
        <div class="schedule-button__wrapper">
          <div class="material-symbols-outlined schedule-button__icon">
            calendar_clock
          </div>
          <div class="schedule-button__label-container">
            <div class="schedule-button__top-label">
              {{ data.channel.is_external ? 'View' : 'Edit' }}
            </div>
            <div>Schedule</div>
          </div>
        </div>
      </button>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="form-content">
      <ng-container *ngTemplateOutlet="content"></ng-container>

      <ng-template #content>
        <div class="channel-dialog-label">Station Information</div>
        <form class="channels-dialog-form" [formGroup]="channelForm">
          <div class="left-side">
            <div>
              <mat-form-field appearance="fill">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" data-testId="channel-name-input" />
                <mat-error *ngIf="showErrorMessage('name')" data-testId="channel-name-input-error">
                  This field is required. Limit of 100 characters.
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="fill">
                <mat-label>Stream Address</mat-label>
                <textarea matInput formControlName="stream_source" class="channel-address-input"
                  data-testId="channel-address-input"></textarea>
                <mat-error *ngIf="showErrorMessage('stream_source')" data-testId="channel-address-input-error">
                  Add a valid stream protocol ('http://', 'https://', 'udp://&#64;', 'rtp://&#64;', 'rtsp://', 'rtmp://',
                  'mms://').
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="right-side">
            <app-logo-selector class="channel-dialog-logo-selector" [dataSet]="data.logosLibrary"
              [selectedItem]="selectedLogo" [disabled]="readOnlyMode"
              (logoSelected)="logoUpdated($event)"></app-logo-selector>
            <div class="logo-preview">
              <div class="logo-preview__wrapper">
                <img [src]="selectedLogo.path" class="channel-logo-image" alt="channel-logo-preview"
                  data-testId="channel-dialog-logo-preview" />
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="dialog-buttons">
    <div>
      <button *ngIf="data.code === 'edit-channel' && !readOnlyMode" mat-stroked-button color="warn" (click)="delete()"
        data-testId="channel-dialog-delete-button">
        Delete
      </button>
    </div>
    <div>
      <button mat-stroked-button color="basic" (click)="closeDialog('')" data-testId="channel-dialog-cancel-button">
        Cancel
      </button>
      <button mat-raised-button color="accent" (click)="save()"
        [disabled]="disableSaveButton()" data-testId="channel-dialog-save-button">
        Save
      </button>
    </div>
  </div>
</div>
